import React from "react";
import { Option } from "@mui/joy";
import DarkSelect from "../../common/DarkSelect";
import type { TrainingTemplate } from "../../../api/training/Training.typed";
import { trainingsQualificationSelectSx } from "../../../styles/globalStyles";
import { TRAININGS_QUALIFICATION_SELECT_PLACEHOLDER } from "./trainingsUiCopy";

export type TrainingsQualificationSelectProps = {
  templates: readonly TrainingTemplate[] | null | undefined;
  value: string;
  onChange: (newValue: string | null) => void;
  emptyStateDisabledOptionLabel?: string;
  trailingInGroup?: React.ReactNode;
};

export default function TrainingsQualificationSelect({
  templates,
  value,
  onChange,
  emptyStateDisabledOptionLabel,
  trailingInGroup,
}: TrainingsQualificationSelectProps) {
  const list = templates ?? [];
  const validTemplates = list.filter((template) => template?.ID != null);

  return (
    <>
      <DarkSelect
        placeholder={TRAININGS_QUALIFICATION_SELECT_PLACEHOLDER}
        value={value}
        onChange={(_event, newValue) => onChange(newValue)}
        sx={trainingsQualificationSelectSx}
      >
        {validTemplates.length > 0 ? (
          validTemplates.map((template) => (
            <Option key={template.ID} value={template.ID.toString()}>
              {template.Agency + " - " + template.Qualification}
            </Option>
          ))
        ) : emptyStateDisabledOptionLabel ? (
          <Option disabled value="">
            {emptyStateDisabledOptionLabel}
          </Option>
        ) : null}
      </DarkSelect>
      {trailingInGroup}
    </>
  );
}
